import React, { useEffect, useReducer, useRef, useState } from "react";
import Typed from 'typed.js';
import ReactDOM from "react-dom";
import "./main.less";
import eventBus from "../../../../../util/eventBus";
import { Icon, Tooltip, Button, Popconfirm } from "@kdcloudjs/kdesign";
import { ReleaseOne } from '@kdcloudjs/kdesign-icons'
import "@kdcloudjs/kdesign/dist/kdesign.css";
import { getReactComponent } from "../../../../../util/reactComponent";
import { useClickAway } from "ahooks";
import "./main.less";
import Lottie from 'react-lottie';
import loadingAnimationData from './components/waiting/loading.json';
// import Img from './assets/basic-gpt.png'
import Img from './assets/gpt.png'
import Img2 from './assets/logogpt.png'

import KeyCode from './utils/keyCode'
import { data } from "./mock";
/**
 * 在setHtml中声明Root类，使用ReactDOM.render将其渲染在model.dom中
 * 在Root类的componentDidMount里，声明一个订阅，用于接收后端更新发过来的消息，从而去更新组件
 * 在update里，发布一个消息，当后端插件给自定义控件传递新数据时，就能将消息发布给Root
 * 在Root类的componentWillUnmount里，取消订阅
 * 在destoryed里，使用ReactDOM.unmountComponentAtNode卸载Root
 * 注意loadFile中index.css的引入路径，因为webpack打包后将其放在了css文件夹里，所以路径是./css/index.css
 */
(function (KDApi) {
  var setHtml = function (model, primaryProps, { I18N }) {
    KDApi.loadFile("./css/index.css", model, () => {
      const Root = (props) => {
        console.log(props);
        const allWrapperRef = useRef();
        const containerRef = useRef();
        const basicMainRef = useRef();
        const buttonWrapperRef = useRef();
        const typewriterRef = useRef(null);
        const bottomElementRef = useRef(null);
        // console.log(props?.customProps?.data?.data, 'props?.customProps?.data?.data')
        const [
          { value, result = {}, loading, pageStatus, stopStatus, visible },
          setData,
        ] = useState(props?.customProps?.data?.data || {});
        const str = '基于当前招聘职位信息，智能生成工作职责和任职要求'
        const [title, setTitle] = useState(str)
        // const [completeTyped, setCompleteTyped] = useState(true)
        const handleButtonClick = (type) => {
          // console.log('清除定时器，按钮')

          clearInterval(bottomElementRef?.current?.intervalId)
          // console.log(type);
          // type: finish new  // close stop 不需要传给后端 前端做数据操作
          if (type === "close") {
            console.log("close");
            setData((data) => ({
              ...data,
              result: {},
              visible: false,
            }));
            setTitle(str)
            console.log("close 222");
          } else if (type === "stop") {
            setData((data) => ({
              ...data,
              loading: false,
              stopStatus: true,
              visible: false,
            }));
            setTitle(str)
          } else if (type === "finish") {
            model.invoke("generate", {
              type,
              result: result,
            });
            setData((data) => ({
              ...data,
              loading: false,
              visible: false,
              result: {},
              value: "",
            }));

          } else {
            // new
            model.invoke("generate", {
              type,
              result: value,
            });
            if (value) {
              setTitle(value)
            } else {
              setTitle(str)
            }
            console.log(visible);
            setData((data) => ({
              ...data,
              loading: true,
              visible: true,
              result: {},
              value: "",
            }));
          }
        };

        useClickAway(() => {
          // console.log("click out side");
          // if (visible) {
          //   console.log("visible", visible);
          //   setData((data) => ({
          //     ...data,
          //     visible: false,
          //     value: "",
          //     loading: false,
          //     result: {},
          //   }));
          //   setTitle(str)
          //   clearInterval(bottomElementRef?.current?.intervalId)
          // }
          // console.log("click out side");
        }, [containerRef, basicMainRef, buttonWrapperRef]);
        useEffect(() => {
          // console.log(result?.jobduty, 'result?.jobduty')
          // console.log(result, 'resultbianhua')
          // result?.jobrequire = undefined
          if (typewriterRef.current && (result?.jobduty?.length > 0 || result?.jobrequire?.length > 0 || result?.other?.length > 0 || result?.before?.length > 0 || result?.after?.length > 0)) {
            const text = result?.other || ((result?.before || '') + (result?.jobduty || '') + (result?.jobrequire || '') + (result?.after || ''));
            console.log(result, 'texttexttext')
            const options = {
              strings: [text],
              typeSpeed: 20,
              loop: false,
              showCursor: true,
              onComplete: () => {
                setData((data) => ({
                  ...data,
                  loading: false,
                }));
                // console.log('清除定时器，打字')
                clearInterval(bottomElementRef.current?.intervalId)
                typewriterRef.current.nextSibling.style.display = 'none';
              },
            };

            const typed = new Typed(typewriterRef.current, options);
            return () => {
              typed.destroy();
            };

          }

        }, [result]);
        const scrollToBottom = (dom) => {
          dom?.scrollIntoView({ block: 'nearest' })
        }
        useEffect(() => {
          clearInterval(bottomElementRef?.current?.intervalId);
          if (!bottomElementRef.current) return
          if (Object.keys(result).length === 0) return
          // clearInterval(bottomElementRef?.current?.intervalId);
          // console.log('新增定时器');
          bottomElementRef.current.intervalId = setInterval(() => {
            scrollToBottom(bottomElementRef.current)
          }, 100)
          return () => clearInterval(bottomElementRef?.current?.intervalId);
        }, [bottomElementRef.current, result])
        useEffect(() => {
          const updateSub = eventBus.sub(model, "update", (customProps) => {
            console.log("校准会传输过来的数据", customProps);
            if (customProps?.data?.eventName === "changePageStatus") {
              setData((data) => ({
                ...data,
                pageStatus: customProps?.data?.data?.pageStatus,
              }));
            }
            if (customProps?.data?.eventName === "generate") {
              // console.log(stopStatus, 'stopStatusstopStatusstopStatus')

              if (stopStatus) {
                // console.log(stopStatus, 'stopStatusstopStatusstopStatus')
                setData((data) => ({ ...data, stopStatus: false }));
              } else {
                // console.log('setData, ')
                setData((data) => ({
                  ...data,
                  result: customProps?.data?.data?.result,
                  // loading: false,
                  // visible: true,
                }));
              }
            }
          });
          return () => {
            eventBus.unsub(updateSub);
          };
        }, []);

        const isEdit = pageStatus === "edit";
        const onInternalKeyDown = (e) => {
          const { which } = e
          // esc
          if (which === KeyCode.ESC) {
            handleButtonClick('stop')
          }
          // optionsList: up、down、enter
        }
        useEffect(() => {
          window.addEventListener('keydown', onInternalKeyDown)
          return () => {
            window.removeEventListener('keydown', onInternalKeyDown)
          }
        }, [])
        return (
          <div
            className={"basic-gpt-container"}
            id={"basic-gpt-container" + model.pageId}
            onClick={(e) => e.stopPropagation()}
            ref={allWrapperRef}
          >
            
            <div
              ref={basicMainRef}
              className="basic-gpt-main"
              id={"basic-gpt-main" + model.pageId}
              style={{ width: "100%" }}
            >
              {visible ? (
                <>
                  {(result && (result.jobduty || result.jobrequire || result.other)) ||
                  loading ? (
                    <div className="gpt-result-container">
                      <div className="result-content">
                        <div className="result-title">{title}</div>
                        <span></span>
                        {/* className={`result-content-main ${
                          (result && (result.jobduty || result.jobrequire || result.other)) ? "has-magin" : ""
                        }` */}
                        <div className={`result-content-main ${(result && (result.jobduty || result.jobrequire || result.other)) ? "has-margin": ''}`}>
                          <span ref={typewriterRef}></span>
                          {loading ? (<div ref={bottomElementRef} style={{ height: '1px', flexShrink: 0 }}></div>) :null}
                          {/* <div ref={bottomElementRef} style={{ height: '1px', flexShrink: 0 }}></div> */}

                          {/* <div className="result-part">
                            <div>{result?.jobduty}</div>
                          </div>
                          <br />
                          <div className="result-part">
                            <div>{result?.jobrequire}</div>
                          </div> */}
                        </div>
                      </div>
                      {loading ? (
                        <div className="loading">
                          {/* <div className="loading-circle">
                            {["#00CCFF", "#0086EF", "#04C7C6", "#B06DFF"].map(
                              (color) => (
                                <div style={{ background: color }}></div>
                              )
                            )}
                          </div> */}
                          <div>
                            <Lottie
                              height={40}
                              width={40}
                              isClickToPauseDisabled={true}
                              options={{
                                animationData: loadingAnimationData,
                                loop: true,
                                autoplay: true,
                              }}
                            />
                          </div>
                          <div style={{ "marginLeft": '12px' }}>正在生成中...</div>
                          <div
                            className="loading-stop"
                            onClick={(e) => {
                              handleButtonClick("stop");
                            }}
                          >
                            {"停止"}
                            <div>ESC</div>
                          </div>
                        </div>
                      ) : (
                        <div
                          className={"button-group-wrapper"}
                          ref={buttonWrapperRef}
                        >
                          <Button
                            type={"primary"}
                            icon={<Icon type={"right"} />}
                            onClick={(e) => {
                              handleButtonClick("finish");
                            }}
                          >
                            {/* {I18N("finish")}
                             */}
                            完成
                          </Button>
                          <Button
                            icon={<Icon type={"refresh"} />}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleButtonClick("new");
                            }}
                          >
                            {/* {I18N("refresh")} */}
                            {"重新生成"}
                          </Button>
                          <Button
                            icon={<Icon type={"close"} />}
                            onClick={() => handleButtonClick("close")}
                          >
                            {/* {I18N("abandon")} */}

                            {"弃用"}
                          </Button>
                        </div>
                      )}
                    </div>
                  ) : null}
                  {
                    loading ? null :
                    (
                    <div className="gpt-question-container">
                    <div className="question-header">
                      <img src={Img2} alt="" />
                      <div>{"补充要求"}</div>
                      <div className="question-tip">
                        AI生成内容可能有误，请结合经验使用
                      </div>
                    </div>
                    <input
                      placeholder={"您可以补充JD生成的要求"}
                      className="question-input"
                      value={value}
                      onKeyDown={(e) => {
                        const { which } = e
                        // esc
                        if (which === KeyCode.ENTER) {
                          handleButtonClick('new')
                        }
                      }}
                      onChange={(e) => {
                        const value = e.target.value;
                        setData((data) => ({ ...data, value }));
                      }}
                    />
                    <ReleaseOne
                      type={"location"}
                      className="location-icon"
                      style={
                        loading || !isEdit || !value
                          ? { pointerEvents: "none", color: "#999999" }
                          : { pointerEvents: "auto" }
                      }
                      onClick={() => {
                        handleButtonClick("new");
                      }}
                    />
                  </div>
                    )
                  }
                  
                </>
              ) : null}
            </div>
            <div
              ref={containerRef}
              className="gpt-basic-popover-wrapper"
              style={{ pointerEvents: isEdit ? "auto" : "none" }}
            >
              <Button disabled={!isEdit} className={!isEdit ? 'disabled': ''} style={{ padding: "0" }} size="large" onClick={() => {
                // if (visible) return;
                // setData((data) => ({
                //   ...data,
                //   visible: true,
                //   loading: true,
                //   value:
                //     data.value ||
                //     "",
                // }));
                // setTitle(str)
                console.log('generate', 'click')
                model.invoke("generate", {
                  type: "click",
                });
              }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "0 8px",
                  }}
                >
                  <img src={Img} alt="" />
                  <div>JD生成</div>
                </div>
              </Button>
              <span style={{ marginLeft: "10px", lineHeight: "32px" }}>
                完善招聘职位信息，有助于更准确生成工作职责和任职要求，请至少输入招聘职位名称
              </span>
            </div>
          </div >
        );
};
ReactDOM.render(
  <Root model={model} customProps={primaryProps} I18N={I18N} />,
  model.dom
);
    });
  };

const ReactComponent = getReactComponent(setHtml);
// 注册自定义组件
KDApi.register("basicGPT", ReactComponent);
}) (window.KDApi);
